import { map, filter } from 'rxjs/operators';
import { Component, OnInit, Output, EventEmitter, Input, OnDestroy, OnChanges, ChangeDetectorRef, SimpleChanges, ChangeDetectionStrategy, ElementRef, Inject, ViewChild, AfterViewInit, QueryList, ViewChildren } from '@angular/core';
import { InboxService } from "../../services/inbox.service";
import { NotificationService } from "../../common/services/notifications.service"
import { TabDataService } from '../../services/tab-data.service';
import { UserDataService } from "../../services/user-data.service";
import { DomSanitizer, SafeUrl, SafeResourceUrl } from "@angular/platform-browser";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { QmaConstant } from '../../constant/qma-constant';
import { LeftNavigationService } from '../leftnav/leftnav.service';
import { OverlayPanel } from "primeng/overlaypanel";
import { RadioButtonModule } from 'primeng/radiobutton';
import { GroupAdminService } from "../../services/group-admin/group-admin.service";
import { DOCUMENT } from "@angular/common";
import { RightNavigationService } from '../../services/panel/panel.service';
import { SymphonyNotificationService } from '../../common/services/Symphony-notifications.service ';
import { SymphonyChatServiceService } from '../../symphony/service/symphony-chat-service.service';
import { PiwikProUtils } from '../../common/utility/piwikProUtils';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { AppUtils } from '../../common/utility/appUtil';
import { TaskizeAuthService } from '../../services/taskize-auth.service';

import $ from 'jquery';
import { ROUTER_CONFIGURATION } from '@angular/router';
import { Subscription } from 'rxjs';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ExpTinyComponent } from '../../common/component/exp-tiny/exp-tiny.component';
import { MessageService } from 'primeng/api';
import { HelpService } from '../../services/help/help.service';
import { NewMessageService } from '../../services/newMessage/new-message.service';
import {
  copyBlobToClipboard,
} from 'copy-image-clipboard';

interface attachmentOption {
  name: string,
  id: string,
  fileInfo: any
}

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss']
})
export class TopnavComponent implements OnInit, OnChanges, AfterViewInit {
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  myForm;


  // @Output() optionClicked = new EventEmitter();
  @Output() advanceSearchToggle = new EventEmitter();
  @Input() advanceSearchVisible: boolean = false;
  @Input() clearCriteria: boolean = true;
  showMultiSelection: boolean = false;
  inputFocused: boolean = false;
  isMobileSearchView: boolean = false;
  notificationCount: number;
  symphonyNotificationCount: number;
  advCriteriaToggle: any = true;
  firstClick: boolean = true;
  val2: string = 'DATE';
  currentTab: any = {
    header: 'Assigned To Me',
    count: 0
  };
  profilePic: any;
  showClearIcon: boolean = false;
  clickStatusArray: boolean[] = [];
  userId: string = "";
  isMobile: boolean;
  tabs: any = {};
  displaySuccess: boolean = false;

  relaseDoc: any;
  display: boolean = false;

  searchForm: FormGroup ;
  public showSearchError: boolean = false;
  protected cachedTabs = {};
  sortAttrNames = ["Date", "Subject", "From"];
  sortAttrIndex: any = 0;
  sortDirection: boolean = false;
  sortDirectionLabel: string = "By Date";

  CSI: string;
  AUID: string;
  AuthKey: string;
  profilePicSrc: string;
  displayChatPopup: boolean = false;
  isScriptLoaded: boolean = false;

  //symphony stream id
  @Input() streamId: String = '';
  @Output() closeChatViewEmit = new EventEmitter();
  symphonyEnabled: boolean = false;
  support_for_ukraine_url = QmaConstant.SUPPORT_FOR_UKRAINE_URL;
  loginUserInfoData: any;
  isTaskizeEnabledForUser: any;
  windowHandle: Window;
  searchInFolders = [{ label: 'All', value: 'All' },
  { label: 'Inbox', value: 'Inbox' },
  { label: 'Pending Approval', value: 'Pending Approval' },
  { label: 'Resolved', value: 'Resolved' },
  { label: 'Sent', value: 'Sent' },
  ];
  selectedFolder: string = 'All';

  searchText: any;
  // arrSavedSearch :any = [{name:'TestSeach'},{name:'TestSeach2'}];
  arrSavedSearch: any = [];
  savedSeachSingle: any[];
  txtPlaceholder = 'Search'
  smartSearchTopInitialkeywordsCount = 5;
  searchTextLength = 0;
  smartSearchCharactersLimit = 0;
  releaseNoteUrl: Blob;
  selectedMenu: string = 'dashboard';
  searchboxClicked: boolean = false;
  isMegaMenuOpen = false; // Mega menu hidden
  isReportsMegaMenuOpen = false;

  @ViewChild('op') overlayPanel: OverlayPanel;
  @ViewChildren(ExpTinyComponent) editorList: QueryList<ExpTinyComponent>;
  @ViewChild('uploadFiles', { static: true }) uploadFiles: ElementRef;

  editorFlag: boolean = false;
  postDataForAttachmentFile: Array<any> = [];
  files: FileList;
  public errMsg = "";
  public displayError = false;
  attachmentLength: any = 0;
  attachmentsOptions: any = [];
  attachments: any[];
  isElipsisShow: boolean = false;
  requestTypes = [];
  priorities = [];
  supportDisplay: boolean = false;
  requestType: string = '';
  priority: string;
  subject: string;
  feedbackText: string = ' ';
  public parentForm: FormGroup;
  isDropdownOpen = false;
  trainingUrl: string = 'https://deltacapita.sharepoint.com/:u:/s/QwynProduct-QwynUserResourceChannel/Ea6A1j-2tKlMn5TbnHO4JPMB2fGVn2zgWfOHdsdTMSej5g?e=YovbrX';
  releaseNotesUrl: string = 'https://deltacapita.sharepoint.com/sites/DCQwynUserCommunity/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FDCQwynUserCommunity%2FShared%20Documents%2FProduct%20News%2FRelease%20Notes&p=true&ga=1';
  supportFeedbackTitle: string = '';
  supportType: string = '';
  isHovered: boolean = false;
  selectedGroupList = [];

  //  Flag to check if user have group role.
  hasGroupRole: boolean = true;

  menuIconImageConfig = {
    copyIconmouseOut: 'assets/Inbox/copy-iconn-darkblue.svg',
    copyIconmouseOn: 'assets/Inbox/copy-iconn-lightblue.svg',
    copyIconSrc: 'assets/Inbox/copy-iconn-darkblue.svg',
    viewIconmouseOut: 'assets/Inbox/eye-icon-darkblue.svg',
    viewIconmouseOn: 'assets/Inbox/eye-icon-lightblue.svg',
    viewIconSrc: 'assets/Inbox/eye-icon-darkblue.svg',
    downloadIconmouseOut: 'assets/Inbox/download-icon_darkblue.svg',
    downloadIconmouseOn: 'assets/Inbox/download-icon_lightblue.svg',
    downloadIconSrc: 'assets/Inbox/download-icon_darkblue.svg',
    copyAllIconmouseOut: 'assets/Inbox/copy-iconn-darkblue.svg',
    copyAllIconmouseOn: 'assets/Inbox/copy-iconn-lightblue.svg',
    copyAllIconSrc: 'assets/Inbox/copy-iconn-darkblue.svg',
    downloadAllIconmouseOut: 'assets/Inbox/download-icon_darkblue.svg',
    downloadAllIconmouseOn: 'assets/Inbox/download-icon_lightblue.svg',
    downloadAllIconSrc: 'assets/Inbox/download-icon_darkblue.svg',

  }
  sAttachViewUrl: string;
  private blobUrls: string[] = [];
  private filePreviewsMap = new Map<string, any>();// Maps filename to preview data
  showPreviewModal = false;
  currentPreviewFile = null;
  isChevronUp: boolean = false;


  constructor(private inboxService: InboxService,
    private notificationService: NotificationService,
    private tabDataService: TabDataService,
    public userDataService: UserDataService,
    private sanitizer: DomSanitizer,
    private builder: FormBuilder,
    private leftNavigationService: LeftNavigationService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private groupAdminService: GroupAdminService,
    private rightNavigationService: RightNavigationService,
    @Inject(DOCUMENT) private document: any,
    private symphonyNotificationService: SymphonyNotificationService,
    private symphonyChatService: SymphonyChatServiceService,
    private dashboardService: DashboardService,
    private taskizeService: TaskizeAuthService,
    private sideNavmponent: SidenavComponent,
    private http:HttpClient,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private helpService: HelpService,
    private newMessageService: NewMessageService,
  ) {
    this.requestTypes.push({ label: "Request Type:", value: "Request Type:" });
    this.requestTypes.push({ label: "Enhancement", value: "Enhancement" });
    this.requestTypes.push({ label: "General Feedback", value: "General Feedback" });


    this.priorities.push({ label: "Highest", value: "Highest" });
    this.priorities.push({ label: "High", value: "High" });
    this.priorities.push({ label: "Medium", value: "Medium" });
    this.priorities.push({ label: "Low", value: "Low" });
    // this.cdr.detach();
    this.isMobile = (window.innerWidth <= QmaConstant.MOBILE_WIDTH);

    this.tabDataService.getTabData().subscribe(tab => {

      // skip setting 'tab.header' to SEARCH in mobile version (which is not displayed)
      if (tab.header !== 'SEARCH') {
        this.currentTab = tab;

        // QMA-1320 - if tab header is this, then set selectedMenu to that, else, set it to messages, since everything is inside messages
        if (tab.header === 'DASHBOARD' || tab.header === 'GROUPADMIN' || tab.header === 'REPORTS') {
          this.selectedMenu = tab.header;
        }
        else if (QmaConstant.QMA_REPORT_TYPES.includes(tab.header) || QmaConstant.QMA_MIS_DASHBOARD_TYPES.includes(tab.header) || tab.header === 'REPORT CRITERIA') {
          this.selectedMenu = 'reports';
        }
        else {
          this.selectedMenu ='messages';
        }

        this.cdr.detectChanges();
      }
      if (this.isMobile && tab.header) {
        // cache the tab in a separate field, so that it may be restored if needed.
        this.tabs[tab.header] = tab;
      }
      if ((tab.header as String).includes('NEW MESSAGE') || (tab.header as String).includes(QmaConstant.QMA_NEW_BUBBLE) || tab.header == 'DASHBOARD') {
        this.showMultiSelection = false;
      }
      else {
        this.showMultiSelection = true;
      }
    });

  this.searchForm = this.builder.group({
    searchText: new FormControl('', Validators.required),
    frmCtrlsearchInFolders: new FormControl('All')
  });
    this.tabDataService.getMessageMenuToggleData().subscribe(tab => {
      if (tab === true) {
        this.selectedMenu = 'messages';
        this.cdr.detectChanges();
      }
    });

    this.tabDataService.listenMobile().subscribe(mob => {

      //  this.isMobile = mob;
    })
    this.myForm = this.fb.group({
      myRadio: ['DATE', []]
    })

    // check symphony entitlement
    this.symphonyChatService.getSymphonyEntitlement().subscribe((entitlement: any) => {
      if (entitlement && entitlement.status && this.userDataService.loggedInUserInfo && this.userDataService.loggedInUserInfo.symphonyConfig
        && this.userDataService.loggedInUserInfo.symphonyConfig.symphonyEnabled && this.userDataService.loggedInUserInfo.isSymphonyEnabledForUser == 'Y') {
        this.symphonyEnabled = true;
      }
      else {
        this.symphonyEnabled = false;
      }
    });

    // check taskize Entitlement
    if (this.userDataService.loggedInUserInfo && this.userDataService.loggedInUserInfo.taskizeConfig && this.userDataService.loggedInUserInfo.taskizeConfig.taskizeEnabled && this.userDataService.loggedInUserInfo.isTaskizeEnabledForUser && this.userDataService.loggedInUserInfo.isTaskizeEnabledForUser?.toUpperCase() == 'Y') {
      this.isTaskizeEnabledForUser = true;
    } else {
      this.isTaskizeEnabledForUser = false;
    }

    // update unread count for mobile
    if (this.isMobile) {
      this.updateUnreadCount();
    }
    this.initSmartSearchCharactersLimit();
  }

  /**
   * Initialize the smart search characters limit.
   * Uses the value from qmaUI2Config if available, otherwise falls back to QmaConstant.
   * Extracted into a method for testability.
   */
  private initSmartSearchCharactersLimit(): void {
    this.smartSearchCharactersLimit = this.userDataService?.loggedInUserInfo?.qmaUI2Config?.smartSearchCharactersLimit 
      || QmaConstant.SMARTSEARCHChARACTERSLimit;
  }

  // QMA-1293
  toggleHelpOverlay(event) {
      this.overlayPanel.toggle(event);
  }

  expandSearchBox(event) {
    if (event.currentTarget.name && event.currentTarget.name === 'searchBtn') {
      this.inputFocused = true;
      this.showClearIcon = false;
    }
  }

  getAttachementImageByExtension(attachement) {
    let fileName = attachement?.name;
    // Get the file extension
    const extension = fileName.split('.').pop()?.toLowerCase();
    // Return the appropriate icon path based on the file extension
    switch (extension) {
      case 'xls':
      case 'xlsx':
        return 'assets/Inbox/fileTypeXLS.svg';
      case 'png':
        return 'assets/Inbox/fileTypePNG.svg';
      case 'jpg':
      case 'jpeg':
        return 'assets/Inbox/fileTypeJPG.svg';
      case 'zip':
        return 'assets/Inbox/fileTypeZIP.svg';
      case 'ppt':
      case 'pptx':
        return 'assets/Inbox/fileTypePPT.svg';
      case 'doc':
        return 'assets/Inbox/fileTypeDOC.svg';
      case 'docx':
        return 'assets/Inbox/fileTypeDOCX.svg';
      case 'svg':
        return 'assets/Inbox/fileTypeSVG.svg';
      case 'pdf':
        return 'assets/Inbox/fileTypePDF.svg';
      case 'html':
        return 'assets/Inbox/fileTypeHTML.svg';
      case 'csv':
        return 'assets/Inbox/fileTypeCSV.svg';
      default:
        return 'assets/Inbox/fileTypeDOC.svg'; // Default icon for other file types
    }
  }

  resetSearchBox(event: any) {
    // if (!this.isMobile) {
    //   if (!this.advanceSearchVisible && (!event.srcElement || event.srcElement.id !== 'cancel-search-topnav')) {
    //     this.inputFocused = false;
    //     this.txtPlaceholder = this.inputFocused? 'Search by inquiry id, assigned group, email content and others…':'Search...';
    //   }
    // } else {
    //   // TBD: to be finalized what are the cases when outside clicks shall hide the search box
    // }
    // // this.cdr.detectChanges();
    // this.cdr.reattach();
  }

  enableBackButton() {
    this.inputFocused = false;
    this.isMobileSearchView = false;
    this.inboxService.disableMobileSearch();
    // clear search at component level - retriggering original request
    this.clearSearch();
  }

  toggleSearch() {
    this.reattchach();
    this.firstClick = false;
    this.advanceSearchVisible = !this.advanceSearchVisible;
    if (this.advanceSearchVisible == false) {
      //reset inputFocus only for web version. The mobile version keep it on until user hits back button
      if (!this.isMobile) {
        this.inputFocused = false;
      }
    }
    this.advanceSearchToggle.emit(this.advanceSearchVisible);
    if (this.advanceSearchVisible == true) {
      PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Search", "Advanced Search", "Click", "Advanced Search", 0);
    }
  }
  cancelSearch(){
    this.searchForm.get('searchText').setValue('');
    this.searchTextLength = 0
  }

  reattchach() {
    this.cdr.reattach();
  }
  mobileSearchClick() {
    this.isMobileSearchView = true;
    this.onFocusEventHandler("");
    this.inboxService.enableMobileSearch();
  }

  checkIfActive() {
    return Array.isArray(this.clickStatusArray) && this.clickStatusArray.includes(true) ? 'isActive' : '';
  }

  onOptionClick(clickedItemIndex: number) {
    //this.optionClicked.emit(clickedItemIndex);
    this.rightNavigationService.open(clickedItemIndex)
  }

  chatViewPopup() {
    if (this.streamId) {
      this.displayChatPopup = true;
    } else {
      this.displayChatPopup = false;
    }

  }

  onClickAdvCriteria() {
    this.advCriteriaToggle = !this.advCriteriaToggle;
  }
  // Global search on texxt enter in top nav search box
  onInputChangeHandler(event: any) {
    let searchText = event.target.value;
    if (searchText.length > 0)
      this.showClearIcon = true;
    else if (searchText.length === 0)
      this.showClearIcon = false;
    else
      this.showClearIcon = false;
    // reset search error if condition is met
    if (searchText.length > 3 && this.showSearchError) {
      this.showSearchError = false;
    }
    this.searchForm.get('searchText').setValue(searchText);
    if (this.isMobile) {
      this.inboxService.onKeySearchText({ text: searchText, forced: false });
    }
  }

  onFocusEventHandler(event: any) {
    this.inputFocused = true;
    let text = this.searchForm.get('searchText').value;
    if (text && text.length > 0) {
      this.showClearIcon = true;
    } else {
      this.showClearIcon = false;
    }
    this.cdr.detectChanges();
  }
  onSelect(event: any, isSolrSearchText: boolean, autocomplete){

    const searchForm = { ...this.searchForm }
    const searchText = searchForm.value.searchText.name ? searchForm.value.searchText.name : searchForm.value.searchText;
    if (searchText.length > 2 && event?.originalEvent?.pointerType === 'mouse') {
      this.showSearchError = false;
      if (!this.isMobile) {
        let reqObj = isSolrSearchText ? { "viewName": "Search", "searchText": searchText, from: 'search' } : { "viewName": "Search", "advanceSearchData": { content: searchText } };

        this.inboxService.requestObj = reqObj;
        this.inboxService.resetRequest = true;
        this.inboxService.searchBoxes = (searchForm.value.frmCtrlsearchInFolders == 'Sent') ? 'Outbox' : searchForm.value.frmCtrlsearchInFolders;
        this.inboxService.triggerMobileSearch('adv-search');
        this.tabDataService.sendTabData("SEARCH", 0);
        // this.loadFormDataToService();
      }
      if (isSolrSearchText && searchForm.value && searchForm.value.searchText && searchForm.value.searchText.id) {
        this.inboxService.requestObj['searchKeyId'] = searchForm.value.searchText.id;
      } else if (isSolrSearchText && searchForm.value && searchForm.value.searchText) {
        this.userDataService.saveSmartSearchFeedback(this.inboxService.requestObj).subscribe((res: any) => {
          if (res.data && res.id)
            this.arrSavedSearch.unshift({ name: this.inboxService.requestObj.searchText, id: res.id });
          this.inboxService.requestObj.searchKeyId = res.id;
        });
      }
      else if (this.isMobile) {
        this.inboxService.triggerMobileSearch('global');
      }
      setTimeout(() => {
        $('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').css('display', 'none');
      }, 0)
    }
    autocomplete.hide()
    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Search", "Quick Search - " + this.currentTab.header, "Type&Search", "Quick Search - " + this.currentTab.header, 0);

  }

  callSearch(event: any, isSolrSearchText: boolean, autocomplete) {
    const searchForm = { ...this.searchForm }
    const searchText = searchForm.value.searchText.name ? searchForm.value.searchText.name : searchForm.value.searchText;
    // this.searchForm.get('searchText').setValue(searchText);
    if (event.keyCode === 13) {
      // if (event.target.value.length > 2) { // Global Search - To have minimum of 3 characters as search criteria
      if (searchText.length > 2) {
        console.log('Text :', event.target.value);
        this.showSearchError = false;
        if (!this.isMobile) {
          let reqObj = isSolrSearchText ? { "viewName": "Search", "searchText": searchText, from: 'search' } : { "viewName": "Search", "advanceSearchData": { content: searchText } };

          this.inboxService.requestObj = reqObj;
          this.inboxService.resetRequest = true;
          this.inboxService.searchBoxes = (searchForm.value.frmCtrlsearchInFolders == 'Sent') ? 'Outbox' : searchForm.value.frmCtrlsearchInFolders;
          this.inboxService.triggerMobileSearch('adv-search');
          this.tabDataService.sendTabData("SEARCH", 0);
          this.tabDataService.drawerStatusChanged.emit(false);
          // this.loadFormDataToService();
        }
        if (isSolrSearchText && searchForm.value && searchForm.value.searchText && searchForm.value.searchText.id) {
          this.inboxService.requestObj['searchKeyId'] = searchForm.value.searchText.id;
        } else if (isSolrSearchText && searchForm.value && searchForm.value.searchText) {
          this.userDataService.saveSmartSearchFeedback(this.inboxService.requestObj).subscribe((res: any) => {
            if (res.data && res.id)
              this.arrSavedSearch.unshift({ name: this.inboxService.requestObj.searchText, id: res.id });
            this.inboxService.requestObj.searchKeyId = res.id;
          });
        }
        else if (this.isMobile) {
          this.inboxService.triggerMobileSearch('global');
        }
        setTimeout(() => {
          $('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').css('display', 'none');
        }, 0)
      }
      else {
        this.showSearchError = true;
      }
      autocomplete.handleDropdownClick();
    }
    autocomplete.hide()
    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Search", "Quick Search - " + this.currentTab.header, "Type&Search", "Quick Search - " + this.currentTab.header, 0);
  }

  triggerSearch(event: any) {
    const text = this.searchForm.get('searchText').value;
    console.log('triggerSearch: text=', text);
    if (text && text.length > 3) {
      this.showSearchError = false;
      if (!this.isMobile) {
        const reqObj = { viewName: "Search", searchText: text, from: 'search' };
        this.inboxService.requestObj = reqObj;
        //reset request since it is a new search
        this.inboxService.resetRequest = true;
        // clear searchBoxes at inbox service
        this.inboxService.searchBoxes = undefined;
        this.tabDataService.sendTabData("SEARCH", 0);
      } else {
        this.inboxService.triggerMobileSearch('global');
      }
    } else {
      this.showSearchError = true;
    }
  }

  ngOnDestroy() {
    this.blobUrls.forEach(url => {
      URL.revokeObjectURL(url);
    });
    this.blobUrls = [];
  }

  ngOnInit() {

    console.log('Testing new changes...!')
    this.parentForm = this.formBuilder.group({
      requestType: new FormControl('', []),
      priority: new FormControl('', []),
      subject: new FormControl('', []),
      attachments: new FormControl('', [])
    });
    this.notificationService.getNotificationCount().subscribe(data => {
      this.notificationCount = data.length
      this.cdr.detectChanges();
    });

    this.symphonyNotificationService.getNotificationCount().subscribe(data => {
      this.symphonyNotificationCount = data.length
      this.cdr.detectChanges();
    }
    );
    this.userDataService.LocalGetLoginUserInfo().subscribe(loginUserInfo => {

      this.loginUserInfoData = loginUserInfo;
      const groups = loginUserInfo.myGroups;
      const groupRoles = loginUserInfo.groupRoles;
      const roleName = 'Group Admin';
      const roleNameAdd = 'Supervisor';
      this.selectedGroupList = [];
      groups.forEach(element => {
        groupRoles.forEach(group => {
          if ((element.groupName == group.groupName) && (group.groupRole.includes(roleName) || group.groupRole.includes(roleNameAdd))) {
            this.selectedGroupList.push({ 'name': element.groupName });
          }
        });
      });
      // Check if user don't have admin access.
      if (this.selectedGroupList === undefined || this.selectedGroupList == null || Object.keys(this.selectedGroupList).length == 0) {
        this.hasGroupRole = false;
      }
      let userPic = loginUserInfo.profilePic;
      this.userId = loginUserInfo.userId;
      this.relaseDoc = loginUserInfo.currentReleaseDocumentName;
      if (userPic) {
        this.profilePic = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + userPic);
      }
      if (loginUserInfo && loginUserInfo.showReleaseDocument && typeof loginUserInfo.currentReleaseDocumentName === 'string' && loginUserInfo.currentReleaseDocumentName.trim() !== '') {
        this.showCurrentReleaseNotes();
      }
      //[C153176-3427] -added below code get profile picture from Global directory
      let globalDirectoryConfig = loginUserInfo.globalDirectoryConfig;
      let userAuthKey = loginUserInfo.userAuthKey;
      if (globalDirectoryConfig) {
        this.CSI = globalDirectoryConfig.csi;
        this.AUID = globalDirectoryConfig.profilePictureConfig.auid;
        this.AuthKey = userAuthKey;
        let picSrc = globalDirectoryConfig.profilePictureConfig.profilePicEndPoint;

        this.profilePicSrc = picSrc + "?authkey=" + this.AuthKey + "&CSI=" + this.CSI + "&AUID=" + this.AUID;

        console.log('making url ' + this.profilePicSrc);
      }
      if (loginUserInfo.qmaUI2Config && loginUserInfo.smartSearchTopInitialkeywordsCount) {
        this.smartSearchTopInitialkeywordsCount = loginUserInfo.smartSearchTopInitialkeywordsCount;
      }
    });
    this.notificationService.listenCount().subscribe((count: any) => {
      this.notificationCount = count.length;
      this.cdr.detectChanges();
    });
    this.symphonyNotificationService.listenCount().subscribe((count: any) => {
      this.symphonyNotificationCount = count.length;
      this.cdr.detectChanges();
      console.log(count);
    });
    this.inboxService.resetSearch.subscribe((event: any) => {
      this.clearSearchText();
    });
    this.inboxService.searchTabEvent.subscribe((event: any) => {
      if (!event || !event.action) {
        return;
      }
      if (event.action === 'addUpdate') {
        if (event.tab) {
          this.cachedTabs[event.tab.toUpperCase()] = this.searchForm.get('searchText').value;
        }
      } else if (event.action === 'close') {
        if (event.tab) {
          if (this.cachedTabs[event.tab.toUpperCase()]) {
            this.clearSearchText();
            this.cachedTabs[event.tab.toUpperCase()] = undefined;
          }
        }
        /*C153176-4795 Mobile change */
        if (this.isMobile) {
          // check current tab from sessionStorage and restore on topnav for mobile version
          let currentTab = sessionStorage.getItem('currentTab');
          if (currentTab) {
            let tab = this.tabs[currentTab];
            if (tab) {
              this.currentTab = tab;
              this.cdr.detectChanges();
            }
          }
        }

      } else if (event.action === 'clear') {
        this.clearSearchText();
      }
    });
    this.userDataService.httpgetSearchKeyWords().subscribe((data: any) => {
      Object.keys(data.data).forEach((k) => {
        if (data.data[k]) {
          this.arrSavedSearch.push({ name: data.data[k], id: k });
        }
      }
      );
      this.addSearchLimitText(this.arrSavedSearch);
      // this.arrSavedSearch.reverse();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.clearCriteria && changes.clearCriteria.currentValue) {
      this.clearSearchText();
    }
    if (changes.streamId && changes.streamId.previousValue !== changes.streamId.currentValue && this.streamId != '') {
      console.log('top nav streamId : ' + this.streamId);
      this.chatViewPopup();
    }
    if (!this.streamId) {
      this.chatViewPopup();
    }

  }

  clearSearchText() {
    // this.searchForm.get('searchText').setValue('');
    this.showSearchError = false;
    this.showClearIcon = false;
  }

  clearSearch() {
    // C153176-5043: align mobile with web version
    this.clearSearchText();
    const reqObj = { viewName: "Search", rollback: 'search' };
    this.inboxService.requestObj = reqObj;
    // C153176-4992: reset request since it is a new search object (rollback of last search)
    this.inboxService.resetRequest = true;
    // C153176-4540: clear searchBoxes at inbox service
    this.inboxService.searchBoxes = undefined;
    // trigger any 'eligible' view to update
    // 'eligible' views: Inbox, Sent, Resolve
    // this.tabDataService.sendTabData("SEARCH", 0, 'updateEligibleViewOnly');
    this.tabDataService.sendTabData("SEARCH", 0, 'resetSearch');
    if (this.isMobile) {
      this.inboxService.onKeySearchText({ text: '', forced: false });
    }
    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Search", "Clear Search", "Click", "Clear Search", 0);
  }

  mobileSelectClick(event?: any) {
    this.inboxService.mobileCheckboxSelected = !this.inboxService.mobileCheckboxSelected;
    this.inboxService.notifyMobileCheckboxSelection();
  }

  mobileSortingClick(event, overlaypanel: OverlayPanel): void {
    overlaypanel.toggle(event);
  }
  closeSortingModal(event, overlaypanel) {
    overlaypanel.hide();

  }

  showHelpReleaseNotes() {
    if (typeof this.relaseDoc === 'string' && this.relaseDoc.trim() !== '') {
      this.showCurrentReleaseNotes();
    } else {
      window.open(this.releaseNotesUrl, '_blank');
    }
    this.overlayPanel.hide();
  }

  closeReleaseNotes() {
    this.display = false;
  }

  showCurrentReleaseNotes() {
    this.display = true;
    const folderUrl = "/QMA2/files/releaseNotesDocuments/";
    let qmaUrl = environment.QMAAPI_URL; // Point to Production URL.

    const token = sessionStorage.getItem('symphony_jwt');
    if (token) {
      const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

      this.http.get(qmaUrl + folderUrl + this.relaseDoc, { headers, responseType: 'blob' }).subscribe(
        (response: Blob) => {
          this.releaseNoteUrl = response;
        },
        (error) => {
          console.error('Error fetching release notes:', error);
        }
      );
    } else {
      console.log('Authorization token is missing!');
    }
  }


  updateReleaseNotesDocument() {
    this.groupAdminService.saveReleaseData().subscribe(result => {
      this.display = false;

    },
      error => {
        this.display = false;
        console.error('Fail To Save User Data Please Contact support ', error);
      });

  }

  mobileSortDirection(event): void {
    this.sortDirection = !this.sortDirection;
    this.cdr.detectChanges();
  }

  displayEllipsis(_count: number) {
    if (_count >= 1000) {
      return ((_count / 1000).toFixed(1) + "k");
    }
    else {
      return _count;
    }
  }

  showSlide(event: Event) {
    this.leftNavigationService.toggle();
    event.stopPropagation();
  }

  sortDirectionClass() {
    return this.sortDirection ? "fa fa-sort-amount-asc" : "fa fa-sort-amount-desc";
  }

  sortAttrLabel() {
    let index = this.sortAttrIndex;
    if (typeof this.sortAttrIndex === 'string') {
      index = parseInt(this.sortAttrIndex);
    }
    this.inboxService.triggerMobileSort({ attr: this.sortAttrNames[index], direction: this.sortDirection });
    return "By " + this.sortAttrNames[index];
  }

  closeChatView(event) {
    console.log("closing chat view ");
    this.displayChatPopup = !this.displayChatPopup;
    this.streamId = '';
    this.closeChatViewEmit.emit(true);
  }
  supportForUkraineClick() {
    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId,
      "Top Nav", "Ukraine Support Link", "Click", "Ukraine Support Link Click", 0);
  }
  updateUnreadCount() {
    this.dashboardService.getUpdatedUnreadCount().subscribe(data => {
      try {
        if (this.isObjetEmpty(data)) {
          return;
        }
        console.log(this.currentTab);
        this.currentTab && this.currentTab.header && data && data.tabName &&
          data.updatedUnread && this.currentTab.header.toUpperCase() === data.tabName.toUpperCase()
          ? this.currentTab.count = data.updatedUnread : this.currentTab.count = this.currentTab.count;
        this.cdr.detectChanges();
      } catch (e) {
        console.error(e);
      }
    });
  }

  isObjetEmpty(obj) {
    return Object.keys(obj).length === 0 ? true : false;

  }

  filterSearchSingle(event) {
    let query = event.query;
    this.savedSeachSingle = this.filterSearch(query, this.arrSavedSearch.filter((item, index, self) =>
      item.name &&
      index === self.findIndex((t) => t.name === item.name)
    ));
  }

  filterSearch(query, savedSearch: any[]): any[] {
    let filtered: any[] = [];
    // in case of blank query show top N results
    if (query === '') {
      filtered = savedSearch.slice(0, this.smartSearchTopInitialkeywordsCount);
    }
    else {
      for (let i = 0; i < savedSearch.length; i++) {
        let search = savedSearch[i];
        if (search.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
          filtered.push(search);
        }
      }
    }
    this.arrSavedSearch.filter(arr => arr.id === -1);
    filtered.push(this.arrSavedSearch.filter(arr => arr.id === -1)[0]);
    return filtered;
  }

  onSearchBoxFocus(autocomplete) {
    // !autocomplete.value && autocomplete.handleDropdownClick();
    if ($('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').length > 0) {
      $('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').css('display', 'inherit');
      return;
    }
    autocomplete.handleDropdownClick();
    setTimeout(() => {
      $('.search-text-container .p-autocomplete-panel')
        .last().css({ "pointer-events": "none", "display": "flex", "opacity": "80%", "color": "gray" });
    }, 0);
  }
  toggleSearchInput() {
    if (!this.isMobile) {
      // let searchedText = this.searchForm.value.searchText && this.searchForm.value.searchText.name?this.searchForm.value.searchText.name:this.searchForm.value.searchText;
      // if(searchedText) {
      //   this.inputFocused = true;
      //    }
      this.inputFocused = true;
      //    else {
      //   this.inputFocused = !this.inputFocused;
      // }
      this.txtPlaceholder = `Search`;
      $('.search-text-container .p-autocomplete-panel');
      if ($('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').length > 0) {
        $('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').css('display', 'inherit');
        $('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').css('left', '0px');
        return;
      }
    }
  }
  clearItem(autocomplete: any) {
    autocomplete.value = '';
    autocomplete.handleDropdownClick();
  }
  closeSearchArea() {
    this.inputFocused = false;
    this.smartSearchCharactersLimit
    this.txtPlaceholder = 'Search';
    this.searchTextLength = 0;
    this.searchForm.reset();
    const reqObj = { viewName: "Search", rollback: 'search' };
    this.inboxService.requestObj = reqObj;
    // C153176-4992: reset request since it is a new search object (rollback of last search)
    this.inboxService.resetRequest = true;
    // C153176-4540: clear searchBoxes at inbox service
    this.inboxService.searchBoxes = undefined;
    this.tabDataService.setsubjectOnTabClose("SEARCH");
    this.tabDataService.sendTabData("SEARCH", 0, 'resetSearch');
  }
  onAutoCompleteSearch(event: any) {
    let searchedData = event.target.value + event.key;
    if (searchedData.length > this.smartSearchCharactersLimit) {
      event.target.value = searchedData.substring(0, this.smartSearchCharactersLimit);
      searchedData = event.target.value;


    }
    this.searchTextLength = searchedData.length;
    // setTimeout(() => {
    // $('.search-text-container .p-autocomplete-panel')
    //   .last().css({ "pointer-events": "none", "display": "flex",  "color": "gray" });
    // $('.search-text-container .p-autocomplete-panel');
    // // }, 0);

    // if ($('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').length > 0) {
    //   $('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').css('display', 'inherit');
    //   $('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').css('left', '0px');
    //   return;
    // }
  }
  onAutoCompleteKeyUp(event: any) {
    // if(event.target.value.length > this.smartSearchCharactersLimit) {
    //   event.target.value = event.target.value.substring(0,this.smartSearchCharactersLimit);
    // }
    this.searchTextLength = event.target.value.length;
    setTimeout(() => {
      $('.search-text-container .p-autocomplete-panel')
        .last().css({ "pointer-events": "none", "display": "flex",  "color": "gray" });
      $('.search-text-container .p-autocomplete-panel');
    }, 0);

    if ($('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').length > 0) {
      $('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').css('display', 'inherit');
      $('.override-newmessage-autocomplete .ng-trigger-overlayAnimation').css('left', '0px');
      return;
    }
  }


  taskizeAuthentication() {
    this.windowHandle = this.taskizeService.createOauthWindow(this.loginUserInfoData);
    this.taskizeService.closeOauthWindow(this.windowHandle)
  }
  addSearchLimitText(arrSavedSearch) {
    let isSearchTextLimitExists = arrSavedSearch.some(data => data.id === -1);
    if (isSearchTextLimitExists) {
      return;
    }
    arrSavedSearch.push({ name: ``, id: -1 })
  }
  selectMenuItem(menu: string, index): void {
    this.selectedMenu = menu;
    if (index === 0) {
      this.sideNavmponent.onClickMenuItem('Dashboard');
      this.tabDataService.setMessageMenuToggleFalse();
    }
    if (index === 1) {
      this.sideNavmponent.onClickMenuItem('Inbox');
      this.tabDataService.setMessageMenuToggleTrue();
    }
    if (index === 2) {
      this.sideNavmponent.onClickMenuItem('reports');
      this.tabDataService.setMessageMenuToggleFalse();
    }
    if (index === 3) {
      this.sideNavmponent.onClickMenuItem('GroupAdmin');
      this.tabDataService.setMessageMenuToggleFalse();
    }
  }
  onInputClick(value) {
    this.searchboxClicked = value
    if (!value) {
      this.searchForm.get('searchText').setValue('');
      this.searchTextLength=0
    }
  }

showSupport(isSupport) {
  this.supportDisplay = true;
  this.overlayPanel.hide();
  this.editorFlag = true;
  this.resetHelp();
  this.postDataForAttachmentFile = [];
  if(isSupport) {
    this.supportFeedbackTitle = 'Get Support';
    this.supportType = 'Support mail';
  } else {
    this.supportFeedbackTitle = 'Submit Feedback';
    this.supportType = 'Feedback';
  }

}
getEditorInstance(id: string): ExpTinyComponent {
    let exp: ExpTinyComponent;
    this.editorList.forEach(div => {
      if (div && div.elementId == id)
        exp = div;
    });
    return exp;
  }
  hideSupport() {
    this.supportDisplay = false;
    this.editorFlag = false;
    this.resetHelp();
    this.postDataForAttachmentFile = [];
  }
  resetHelp(): void {
    this.parentForm.reset();
    this.postDataForAttachmentFile = [];
  }
sendFeedback() {
  try {
    this.feedbackText = this.getEditorInstance("feedbackText").getData();
    if(this.supportFeedbackTitle === 'Get Support') {
      this.requestType = 'Enhancement';
    } else {
      this.requestType = 'General Feedback';
    }
    this.priority = this.parentForm.get('priority').value ? this.parentForm.get('priority').value : '';
    this.subject = this.parentForm.get('subject').value ? this.parentForm.get('subject').value : '';
    let attachment = this.parentForm.get('attachments').value ? this.parentForm.get('attachments').value : [];

    let reqObj = {
      "to": [
        {
          "text": this.userDataService.loggedInUserInfo?.msExchangeServerConfigMap?.SUPPORT_EMAIL,
          "email": this.userDataService.loggedInUserInfo?.msExchangeServerConfigMap?.SUPPORT_EMAIL,
          "value": this.userDataService.loggedInUserInfo?.msExchangeServerConfigMap?.SUPPORT_EMAIL,
          "id": null,
          "isExternal": false
        }
      ],
      "cc": [],
      "from": this.userDataService.loggedInUserInfo?.myGroups[0]?.groupName,
      "urgentFlag": "N",
      "subject": this.subject + " " + "(Priority: " + this.priority + ")",
      "requestType": this.userDataService.loggedInUserInfo?.myGroups[0]?.requestTypes[0],
      "attachment": attachment,
      "inquiryAction": "NEW INQUIRY",
      "Resolve": false,
      "approvalBypassed": false,
      "token": AppUtils.getToken(),
      "isUserEditorPrefUpdated": true,
      "inquirySource": "Email",
      "inquirySubStatus": "",
      "resolveRootCause": "",
      "processingRegion": "",
      "tag": "",
      "queryCount": "",
      "GFPID": "",
      "GFCID": "",
      "GFPIDName": "",
      "GFCIDName": "",
      "bcc": null,
      "memo": null,
      "parentConversation": "",
      "inquiryId": null,
      "suggestionConvId": null,
      "followUp": "",
      "notes": [],
      "skAccountNo": "",
      "branch": ""
    }
    let SupportFeedback_list = {
      action: "USERFEEDBACK",
      notificationFrom: this.userDataService.loggedInUserInfo.email,
      notificationSubject: this.requestType + " " + "(Priority: " + this.priority + ")" + this.subject,
      token: AppUtils.getToken(),
      attachment: attachment
    }
    this.messageService.clear();
    this.newMessageService.saveInquiry(reqObj, this.feedbackText).subscribe(
      (result) => {
        this.displaySuccess = true;

      },
      (error) => {
        // adding error popup if saveInquiry fails
        let displayMessage = 'Something went wrong. Please contact Support';
        this.messageService.add({ key: 'qmaToast', severity: 'error', detail: displayMessage });
        console.log('error while sending email:', error);
      }
    );
    this.helpService.helpNotification(SupportFeedback_list, this.feedbackText).subscribe(result => {
      if (result.processingstatus) {
        this.hideSupport();
        this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Help Success', detail: 'Thank you for providing the feedback, your feedback is captured successfully.' });
      }
    }, error => {
      console.error('Failed to send the feedback due to ', error);
    });
  }
  catch (e) {
    console.error("Exception in QMA 2 while sendFeedback() : ", e);
  }
}
setRestrictedFileNames(restrictedFilesList) {
  this.errMsg  = QmaConstant.QMA_INVALID_FILES_MSG;
  for (let i = 0; i < restrictedFilesList.length; i++) {
    this.errMsg  = this.errMsg + "<br>" + restrictedFilesList[i];
    }
    this.showErrorDialog();
}
showErrorDialog() {
  this.displayError = true;
}
uploadFile() {
  this.uploadFiles.nativeElement.click();

}
checkOverFlow(element) {
  if (element.clientWidth < element.scrollWidth) {
    this.attachmentLength = Math.floor(element.clientWidth / 127);
    return true;
  }
}
deleteAttachedFile(id) {
  let elem = document.getElementById(id);
  elem.remove();
  if (this.postDataForAttachmentFile.length === this.attachmentLength + 1) {
    this.isElipsisShow = true;
  }
  for (let i = 0; i < this.postDataForAttachmentFile.length; i++) {
    if (this.postDataForAttachmentFile[i].id === id) {
      this.postDataForAttachmentFile.splice(i, 1);
    }
  }

  this.parentForm.get('attachments').setValue(this.postDataForAttachmentFile);
}
showRemainingAttchment(event, overlaypanel: OverlayPanel, attachmentList: any): void {
    this.attachmentsOptions = [];
    for (let i = this.attachmentLength; i < attachmentList.length; i++) {
      let attachInfo: attachmentOption = {
        name: attachmentList[i].name,
        id: attachmentList[i].id,
        fileInfo: attachmentList[i]
      };
      this.attachmentsOptions.push(attachInfo);
    }
    overlaypanel.toggle(event);
  }


  createFilePreview(file) {
    // For images
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.filePreviewsMap.set(file.name, {
          type: 'image',
          data: e.target.result,
          file: file
        });
      };
      reader.readAsDataURL(file);
    }
    // For PDFs
    else if (file.type === 'application/pdf') {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.filePreviewsMap.set(file.name, {
          type: 'image',
          data: e.target.result,
          file: file
        });
      };
      reader.readAsDataURL(file);
    }
    // For text files
    else if (file.type.startsWith('text/') ||
             file.type === 'application/json' ||
             file.type === 'application/xml') {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.filePreviewsMap.set(file.name, {
          type: 'image',
          data: e.target.result,
          file: file
        });
      };
      reader.readAsText(file);
    }
    // For other file types, just store metadata
    else {
      this.filePreviewsMap.set(file.name, {
        type: 'image',
        data: null,
        file: file
      });
    }
  }

fileEvent(e) {
  try {
    this.files = e.target.files;
    let data = new FormData();
    let hasInvalidFiles = false;
    let restrictedFilesList = [];
     // C170665-255 Restrict specific file extensions in QMA 2.0
     let QMA_VALID_FILE_EXTENSIONS = this.userDataService.loggedInUserInfo.allowedFileExtensions? this.userDataService.loggedInUserInfo.allowedFileExtensions:
     QmaConstant.QMA_VALID_FILE_EXTENSIONS;
    if (this.files) {
      for (let i = 0; i < this.files.length; i++) {
         // C170665-255 Restrict specific file extensions in QMA 2.0
         this.createFilePreview(this.files[i]);
      if(this.files.item(i).type && QMA_VALID_FILE_EXTENSIONS.includes(this.files.item(i).name.split('.').pop().toLowerCase()))
      {
        data.append('files', this.files.item(i), this.files.item(i).name);
      }else { // if invalid files show error message
        hasInvalidFiles = true;
        restrictedFilesList.push(this.files.item(i).name);
      }
      }

    }
    if(hasInvalidFiles) {
      this.setRestrictedFileNames(restrictedFilesList);
     }
    this.newMessageService.uploadMultipleFiles(data).subscribe(result => {
      this.postDataForAttachmentFile.push(...result);
      this.parentForm.get('attachments').setValue(this.postDataForAttachmentFile);
    },
      (error) => {
        console.log('error while feedback file upload :', error);
      }
    );
  } catch (e) {
    console.error("Exception in QMA 2 while fileEvent() : ", e);
  }
}
onMouseEnterNewAttMenu(attachment) {
  this.postDataForAttachmentFile.forEach((att) => {
    if (attachment.id === att.id) {
      att.showMenuNew = true;
      att.showTitleNew = false;
    } else {
      att.showMenuNew = false;
      att.showTitleNew = true;
    }
  });
}

showAttachments(event, overlaypanel: OverlayPanel, attachmentList: any): void {

  this.attachmentsOptions = [];
  // this.copyAllImage = "copy_icon.svg";

  let curVal = sessionStorage.getItem('copiedattch');// C153176-4708	display toaster message on click
  let copiedAttachments = curVal !== null ? curVal.split('~') : null;

  // C153176-5494 | For copied all - To distunguish single is copied or copy all
  // copiedAtmntCount is used. If count is matched with original attachments then its a copy all.
  let copiedAtmntCount = 0;
  if (copiedAttachments) {
    let attachmentNames = [];
    let matchedAttachments = [];
    copiedAttachments.forEach(attachment => {
      if (attachment) {
        attachmentNames.push(attachment.substring(attachment.indexOf(':') + 1, attachment.length).trim());
      }
    });
    matchedAttachments = attachmentList.filter(attachment => attachmentNames.includes(attachment.name));
    copiedAtmntCount = attachmentNames.length === matchedAttachments.length ? attachmentNames.length : 0;
  }

  attachmentList.forEach(attachment => {
    let attachInfo: attachmentOption = {
      name: attachment.name,
      id: attachment.id,
      fileInfo: attachment,
      // imageName: "copy_icon.svg"// C153176-4708	display toaster message on click
    };
    // If selected for copy as an attachment. // C153176-4708	display toaster message on click
    if (curVal !== null && curVal.indexOf(attachInfo.name) > -1 && copiedAtmntCount == 0) {
      // attachInfo.imageName = "copy_icon_blue.svg";
    }
    this.attachmentsOptions.push(attachInfo);
  });

  /*  if (copiedAtmntCount > 1) {
       this.copyAllImage = "copy_icon_blue.svg";
   } */
  if (overlaypanel && event) {
    overlaypanel.toggle(event);
  }

}

onMouseEnterNewAttTitle(attachment) {
  this.postDataForAttachmentFile.forEach((att) => {
    if (attachment.id === att.id) {
      attachment.showMenuNew = true;
      attachment.showTitleNew = false;
    } else {
      att.showMenuNew = false;
      att.showTitleNew = true;
    }
  });
}

onMouseLeaveNewAttMenu(attachment) {
  this.postDataForAttachmentFile.forEach((att) => {
    att.showMenuNew = false;
    att.showTitleNew = true;
  });
}

getViewIconImage(attachement) {
  return attachement && attachement.viewIconUrl ? attachement.viewIconUrl : this.menuIconImageConfig.viewIconSrc;
}
onMouseOverViewIcon(attachement) {
  if (attachement) {
    attachement.viewIconUrl = this.menuIconImageConfig.viewIconmouseOn;
  }
}
onMouseOutViewIcon(attachement) {
  if (attachement) {
    attachement.viewIconUrl = this.menuIconImageConfig.viewIconmouseOut;
  }
}
getDownloadIconImage(attachement) {
  return attachement && attachement.downloadIconUrl ? attachement.downloadIconUrl : this.menuIconImageConfig.downloadIconSrc;
}
onMouseOverDownloadIcon(attachement) {
  if (attachement) {
    attachement.downloadIconUrl = this.menuIconImageConfig.downloadIconmouseOn;
  }
}
onMouseOutDownloadIcon(attachement) {
  if (attachement) {
    attachement.downloadIconUrl = this.menuIconImageConfig.downloadIconmouseOut;
  }
}

onDownloadAction(event, overlaypanel: OverlayPanel): void {
  const selectedAttachment = this.attachmentsOptions.find(option => option.name === event.target.title);
  if (event.target.name == "copy") {

    // C153176-5490 | One last item shoud be available for attachment for attahment.
    // We need to clear the session storage on new attachment request.
    console.log("Only last item should available to paste for attachment");
    sessionStorage.removeItem("copiedattch");
    // this.copyAllImage = "copy_icon.svg";

    let bAddNewAttach: boolean = false;// C153176-4708	display toaster message on click
    let attachments = selectedAttachment.fileInfo;

    this.attachmentsOptions.forEach(attachment => {
      if (attachment.name != attachments.name) {
        attachment.imageName = 'copy_icon.svg';
      }
    });

    if (Array.isArray(attachments)) {
      if (attachments.length === 1) {
        console.log('Only one attachment : ', attachments[0].name);
        let curVal = sessionStorage.getItem('copiedattch');
        if (curVal == null) {
          curVal = '';
          bAddNewAttach = true;
        } else {
          if (curVal.indexOf(attachments[0].name) == -1) {
            bAddNewAttach = true;
          }
        }
        if (bAddNewAttach == true) {
          sessionStorage.setItem('copiedattch', curVal + '~' + this.inboxService.viewAttachment(attachments[0].id, attachments[0].name, attachments[0].convId, attachments[0].groupId, attachments[0].hasNominatedOwnership) + ':' + attachments[0].name);

          // C153176-4648 - Show 'Copied' message on copy of an attachment.
          this.messageService.add({ severity: 'success', key: 'qmaToast', summary: '', detail: 'Copied' });
        }
      }
    }
    else {
      let curVal = sessionStorage.getItem('copiedattch');
      if (curVal == null) {
        curVal = '';
        bAddNewAttach = true;// C153176-4648 - Show 'Copied' message on copy of an attachment.
      } else {
        if (curVal.indexOf(attachments.name) == -1) {
          bAddNewAttach = true;
        }
      }
      if (bAddNewAttach == true) {
        const attachmentUrl =  this.inboxService.copyAttachment(attachments.id, attachments.convId, attachments.groupId, attachments.hasNominatedOwnership);
        sessionStorage.setItem('copiedattch', curVal + '~' + attachmentUrl + ':' + attachments.name);
        let extension = attachments.name.split(".").pop();
        console.log("Extenstion : " + extension);
        if (extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "gif" || extension == "bmp") {
          this.getFileBlob(attachmentUrl);

          // C153176-4648 - Show 'Copied' message on copy of an attachment.
          this.messageService.add({severity: 'success', key: 'qmaToast', summary: '', detail: 'Copied'});
        }
        else{
          this.messageService.add({severity: 'error', key: 'qmaToast', summary: '', detail: 'Selected format is not supported for copying'});
        }
      }
    }
  } else {
    if (overlaypanel) {
      overlaypanel.hide();
    }

    //  this.attachByteArray = this.inboxService.attachBinary;******
    var filename = "";
    if (!Array.isArray(selectedAttachment.fileInfo)) {
      filename = selectedAttachment.fileInfo.name;
    }
    else
      filename = selectedAttachment.fileInfo[0].name;
    var extension = filename.split('.').pop().toLowerCase();

    var isViewed = false;

    console.log('attach file extension ' + extension);

    if ((event && event.target && event.target.classList && event.target.classList.contains('attach-name-opt') === true)
      || event.target.name === "view") {
      // this.setAttachmentUrl(selectedAttachment.fileInfo);
      this.showPreview(selectedAttachment.fileInfo.name);
      if (extension !== 'doc' &&
        extension !== 'ppt' &&
        extension !== 'pptx' &&
        extension !== 'zip' &&
        extension !== 'rar' &&
        extension !== 'wpd' &&
        extension !== 'msg' &&
        extension !== '7z') {
        isViewed = true;
      } else {
        alert('The selected file type is not supported for inline preview');
      }
    }

    if (isViewed === true) {   //view attachment

    } else { //downlad attachment
      this.onDownloadAttachment(selectedAttachment.fileInfo);
    }
  }

}

getFileBlob(attachmentUrl: any) {
  return this.http.get(attachmentUrl, { responseType: "blob" }).subscribe((result: any) => {
    const data =  new Blob([result], { type: "image/png" });
      console.log("Sample data " + data);
      copyBlobToClipboard(data).then(() => {
                console.log("Blob copied to clipboard");
              });
  });
}

setAttachmentUrl(attachments: any): any {
  if (Array.isArray(attachments)) {

    console.log('Only one attachment : ', attachments[0].name);
    this.sAttachViewUrl = this.inboxService.viewAttachment(attachments[0].id, attachments[0].name, attachments[0].convId, attachments[0].groupId, attachments[0].hasNominatedOwnership);
  }
  else {
    console.log('Only one attachment : ', attachments.name);
    this.sAttachViewUrl = this.inboxService.viewAttachment(attachments.id, attachments.name, attachments.convId, attachments.groupId, attachments.hasNominatedOwnership);
  }

}

onDownloadAttachment(fileName: any) {
  let fileNameToUse = fileName.name || fileName;
  let fileData;

  console.log('Attempting to download file:', fileNameToUse);

  // First try direct lookup
  fileData = this.filePreviewsMap.get(fileNameToUse);

  // If not found, try to find it by iterating through the map
  if (!fileData) {
    console.log('Direct lookup failed, searching through all entries...');

    // Convert the map to an array for easier iteration
    const entries = Array.from(this.filePreviewsMap.entries());

    for (const [key, value] of entries) {
      console.log('Checking key:', key);

      // Try exact match first
      if (key === fileNameToUse) {
        fileData = value;
        fileNameToUse = key; // Use the original key for download name
        console.log('Found exact match:', key);
        break;
      }

      // Then try case-insensitive match
      if (key.toLowerCase() === fileNameToUse.toLowerCase()) {
        fileData = value;
        fileNameToUse = key; // Use the original key for download name
        console.log('Found case-insensitive match:', key);
        break;
      }
    }
  }

  if (!fileData) {
    console.error('File not found after searching:', fileNameToUse);
    this.messageService.add({
      severity: 'error',
      key: 'qmaToast',
      summary: '',
      detail: 'File not found'
    });
    return;
  }

  try {
    console.log('Found file data:', fileData);

    // Handle the case where fileData.data is undefined
    if (!fileData.data) {
      console.error('File data is undefined for:', fileNameToUse);
      this.messageService.add({
        severity: 'error',
        key: 'qmaToast',
        summary: '',
        detail: 'Invalid file data'
      });
      return;
    }

    // Create a download link element
    const link = document.createElement('a');

    // Set the href to the file data URL
    link.href = fileData.data;

    // Set download attribute with the file name
    link.download = fileNameToUse;

    // Append to the document
    document.body.appendChild(link);

    // Trigger click event to start download
    link.click();

    // Clean up
    document.body.removeChild(link);

    // Show success message
    this.messageService.add({
      severity: 'success',
      key: 'qmaToast',
      summary: '',
      detail: 'File downloaded successfully'
    });
  } catch (error) {
    console.error('Error downloading file:', error);
    this.messageService.add({
      severity: 'error',
      key: 'qmaToast',
      summary: '',
      detail: 'Error downloading file'
    });
  }
}

onViewctionRedesigned(attachement) {
  let event = { target: { name: 'view', title: attachement.name } };
  this.onDownloadAction(event, null);
}

showPreview(fileName: string) {
  const originalFileData = this.filePreviewsMap.get(fileName);
  if (!originalFileData) {
    console.error('File not found:', fileName);
    return;
  }

  // Clone the file data to avoid modifying the original
  const fileData = { ...originalFileData };

  // For PDFs, convert data URL to blob URL if not already done
  if (fileData.file && fileData.file.type === 'application/pdf') {
    // Check if we already have a blob URL for this file
    if (!fileData.blobUrl) {
      try {
        const dataUrl = fileData.data;
        const byteString = atob(dataUrl.split(',')[1]);
        const mimeType = 'application/pdf';
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeType });

        // Create object URL from Blob
        const blobUrl = URL.createObjectURL(blob);

        // Store the blob URL on the cloned object, not the original
        fileData.blobUrl = blobUrl;

        // Track the URL for later cleanup
        this.blobUrls.push(blobUrl);
      } catch (error) {
        console.error('Error converting PDF to blob:', error);
      }
    }
  }

  this.currentPreviewFile = fileData;
  this.showPreviewModal = true;

  // Manually trigger change detection to update the view
  this.cdr.detectChanges();
}

 onMouseLeaveNewAttTitle(attachment) {
    this.postDataForAttachmentFile.forEach((att) => {
      if (attachment.id === att.id) {
        attachment.showMenuNew = false;
        attachment.showTitleNew = true;
      } else {
        att.showMenuNew = false;
        att.showTitleNew = true;
      }
    });
  }


// Make sure to clean up
closePreview() {
  if (this.currentBlobUrl) {
    URL.revokeObjectURL(this.currentBlobUrl);
    this.currentBlobUrl = null;
  }
  this.showPreviewModal = false;
  this.currentPreviewFile = null;
}

// Add this property
currentBlobUrl: string = null;



getSafeUrl(url: string): SafeUrl {
  return this.sanitizer.bypassSecurityTrustResourceUrl(url);
}

updateAttachments(fileMap: Map<string, any>) {
  this.filePreviewsMap = fileMap;
}


 // Helper methods for type checking
 isImageType(type: string): boolean {
  const imageTypes = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/svg+xml',
    'image/webp',
    'image/bmp',
    'image/tiff'
  ];
  return imageTypes.includes(type);
}

isTextType(type: string): boolean {
  const textTypes = [
    'text/plain',
    'text/html',
    'text/css',
    'text/javascript',
    'text/csv',
    'text/markdown',
    'application/json',
    'application/xml',
    'application/javascript'
  ];
  return textTypes.includes(type);
}



isOfficeType(type: string): boolean {
  const officeTypes = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
    'application/vnd.oasis.opendocument.text', // odt
    'application/vnd.oasis.opendocument.spreadsheet', // ods
    'application/vnd.oasis.opendocument.presentation' // odp
  ];
  return officeTypes.includes(type);
}

isArchiveType(type: string): boolean {
  const archiveTypes = [
    'application/zip',
    'application/x-rar-compressed',
    'application/x-7z-compressed',
    'application/x-tar',
    'application/gzip',
    'application/x-bzip',
    'application/x-bzip2'
  ];
  return archiveTypes.includes(type);
}

getOfficeIconClass(type: string): string {
  if (type.includes('word')) {
    return 'fas fa-file-word';
  } else if (type.includes('spreadsheet') || type.includes('excel')) {
    return 'fas fa-file-excel';
  } else if (type.includes('presentation') || type.includes('powerpoint')) {
    return 'fas fa-file-powerpoint';
  }
  return 'fas fa-file-alt';
}

isSupportedPreviewType(type: string): boolean {
  return this.isImageType(type) ||
         type === 'application/pdf' ||
         this.isTextType(type) ||
         this.isOfficeType(type) ||
         this.isArchiveType(type);
}

viewStyleObject() {
  return {width: '800px', minWidth: '800px', height:'600px'};
}

contentStyleObject() {
  return {overflow: 'auto', width:'100%'};
}

onCopyActionRedesigned(attachement) {
  let event = { target: { name: 'copy', title: attachement.name } };
  this.onDownloadAction(event, null);
}
  isValidReportType(item: string) {
    return QmaConstant.QMA_REPORT_TYPES.includes(item);
  }
}
